import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/wallet-transfer`;

class WalletTransferServices {
  async getDropdownUsers() {
    try {
      const action = `${API_ROUTE}/get-users-list`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getDropdownUsers:", error);
      throw error;
    }
  }
}

export default WalletTransferServices;
